<div class="navigation">
  <div>
    <ts-tree-menu
      title="Views"
      [items]="sidebarItems"
      [actions]="tsTreeActions"
      (action)="onActionClicked($event)"
      [activeNodeFn]="checkViewIsActive"
      [loading]="loading"
      [allowNewItems]="canManagePipeline()"
    >
    </ts-tree-menu>
  </div>
  <hr class="my-4" />

  <div>
    <ts-tree-menu
      title="Saved Filters"
      [items]="sidebarSavedFiltersItems"
      [activeNodeFn]="checkSavedFilterIsActive"
      [disableNodeFn]="disableSavedViewItem"
      [loading]="loading"
    >
    </ts-tree-menu>
  </div>
</div>
